<template>
  <UIModal
    :is-open="isAgeVerificationOpen"
    :title="t('details.ageVerification.title')"
    class-name="!z-[80]"
    @close="cancelAgeVerification"
  >
    <p class="text-sm text-gray-600 dark:text-gray-300">
      {{ t('details.ageVerification.message') }}
    </p>
    <p class="mt-3 text-sm font-medium text-gray-800 dark:text-gray-100">
      {{ t('details.ageVerification.minAgeHint', { age: ageVerificationMinAge }) }}
    </p>

    <template #footer>
      <div class="mt-4 flex justify-end gap-3">
        <UIButton variant="outline" @click="cancelAgeVerification">
          {{ t('details.ageVerification.cancel') }}
        </UIButton>
        <UIButton variant="primary" @click="confirmAgeVerification">
          {{ t('details.ageVerification.confirm') }}
        </UIButton>
      </div>
    </template>
  </UIModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import UIModal from '@/components/ui/UIModal.vue'
import UIButton from '@/components/ui/UIButton.vue'
import { useAgeVerification } from '@/composables/useAgeVerification'

const { t } = useI18n()
const {
  isAgeVerificationOpen,
  ageVerificationMinAge,
  confirmAgeVerification,
  cancelAgeVerification,
} = useAgeVerification()
</script>
